import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Icon button in the top bar that toggles between English and French.
 */
const LanguageToggle = () => {
  const { t } = useTranslation('common');
  const { language, setLanguage } = useLanguage();

  const isFrench = language === 'fr';
  const nextLanguage = isFrench ? 'en' : 'fr';
  const currentCode = isFrench ? 'FR' : 'EN';
  const nextLabel = isFrench ? t('english') : t('french');

  const handleToggle = () => {
    setLanguage(nextLanguage);
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className="flex items-center gap-1.5 h-9 px-2.5 rounded-lg border border-border bg-surface text-text-secondary hover:text-primary hover:border-primary/30 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:ring-offset-2 focus:ring-offset-surface"
      aria-label={t('switchLanguageTo', { language: nextLabel })}
      title={t('switchLanguageTo', { language: nextLabel })}
    >
      <span className="material-symbols-outlined text-[20px]" aria-hidden="true">
        translate
      </span>
      <span className="text-xs font-bold tracking-wide tabular-nums min-w-[1.5rem]">
        {currentCode}
      </span>
    </button>
  );
};

export default LanguageToggle;
